var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "What We Do",
      "tabActive": "Quality Control",
      "bg": "/images/sub/visual/sv4.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "page-tit-wrap"
  }, [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Quality Control ")]), _c('p', [_vm._v(" ISO 9001 품질경영 시스템 절차에 따른 전체 공정의 체계적이고 효율적인 품질관리 시스템 운영 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" SPC 시스템을 통한 트렌드 분석으로 안정적인 품질 확보 ")])])])], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "품질 관리"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto d-none d-md-block",
    attrs: {
      "src": "/images/sub/wwd/control/control-img.png",
      "max-width": "940"
    }
  }), _c('v-img', {
    staticClass: "mx-auto d-block d-md-none",
    attrs: {
      "src": "/images/sub/wwd/control/control-img-mo.png",
      "max-width": "670"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }